/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Organization_SubtitleInputs */



/**
* | output |
* | --- |
* | "Monitor your organization's AI usage, costs, and efficiency" |
*
* @param {Dashboard_Organization_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_organization_subtitle = /** @type {((inputs?: Dashboard_Organization_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Organization_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überwache die KI-Nutzung, Kosten und Effizienz deiner Organisation")
	return /** @type {LocalizedString} */ ("Monitor your organization's AI usage, costs, and efficiency")
});